import { getPortalRuntimeConfig } from '../services/runtimeConfig';

export function getOpenAppWithOTPUrl(uuid: string, otp: string) {
  const { appLink } = getPortalRuntimeConfig();
  return `${appLink}?af_web_dp=https%3A%2F%2Fjoin.onestep.co%2Fopen-on-mobile&af_xp=qr&pid=QR_code&c=clinician_otp_login&deep_link_value=otp_login&deep_link_sub1=${uuid}&deep_link_sub2=${otp}&af_force_deeplink=true`;
}
